/**
 * Get the extension of a path, file... as lowercase.
 * Returns an empty string if the path has no extension
 * to match with the behavior of Node.js path.extname.
 */
export function extname(path: string): string {
    const extension = path.split('.').pop() || '';
    return extension === path ? '' : `.${extension}`.toLowerCase();
}
